<ng-container *ngIf="visible$ | async">
	<div *ngIf="backdrop" class="support-backdrop" (click)="close()">
		<div class="support-dialog" role="dialog" aria-modal="true" aria-label="Request help" (click)="$event.stopPropagation()">
			<div class="support-content">

				<div class="support-header">
					<div class="title-wrap">
						<div class="title">{{ title }}</div>
						<div class="subtitle">
							Help us link or create a help article for this specific error.
						</div>
					</div>

					<button type="button" class="icon-btn" (click)="close()" aria-label="Close">
						✕
					</button>
				</div>

				<div class="support-body">

					<div class="callout" role="note">
						<div class="callout-title">You’re helping improve this error</div>
						<div class="callout-subtitle">
							Support will use your message to add or connect the right help article to this error so future users immediately see guidance.
						</div>
					</div>

					<div class="field">
						<label class="label" for="supportEmail">
							Contact email <span class="hint">(optional)</span>
						</label>
						<input id="supportEmail" class="input" type="email" [(ngModel)]="email" placeholder="name@company.com" autocomplete="email" [disabled]="(uiState$ | async)?.kind === 'submitting'" />
					</div>

					<div class="field">
						<label class="label" for="supportDetails">
							What happened?
						</label>
						<textarea id="supportDetails" class="input" rows="6" [(ngModel)]="details" placeholder="Describe what you were doing, what you expected, and what happened." [disabled]="(uiState$ | async)?.kind === 'submitting'"></textarea>
					</div>

					<ng-container *ngIf="uiState$ | async as state">
						<div class="status" *ngIf="state.kind === 'submitting' || state.kind === 'sent' || state.kind === 'error'" role="status" aria-live="polite">
							<ng-container *ngIf="state.kind === 'submitting'">
								Sending your request…
							</ng-container>

							<ng-container *ngIf="state.kind === 'sent'">
								<ng-container *ngIf="autoCloseIn$ | async as sec; else sentNoTimer">
									Thank you — support will review this and add or link the appropriate help article for this error. Closing in {{ sec }}s…
								</ng-container>
								<ng-template #sentNoTimer>
									Thank you — support will review this and add or link the appropriate help article for this error.
								</ng-template>
							</ng-container>

							<ng-container *ngIf="state.kind === 'error'">
								{{ state.message }}
							</ng-container>
						</div>
					</ng-container>


				</div>

				<div class="support-footer">
					<button type="button" class="btn-ghost" (click)="close()" [disabled]="(uiState$ | async)?.kind === 'submitting'">
						Cancel
					</button>

					<button type="button" class="btn-primary" (click)="submit()" [disabled]="(uiState$ | async)?.kind === 'submitting'">
						{{ (uiState$ | async)?.kind === 'submitting'
						? 'Sending…'
						: 'Send to support' }}
					</button>
				</div>

			</div>
		</div>
	</div>
</ng-container>
